/* ============================================================================
   Florage Theme – global.js
   Cart drawer + AJAX, variant picker, gallery, qty, mobile nav, search, count-up.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.routes || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ----------------------------------------------------------------- CART DRAWER */
  var CartDrawer = {
    el: function () { return $('[data-cart-drawer]'); },
    overlay: function () { return $('[data-cart-overlay]'); },
    open: function () {
      var d = this.el(); var o = this.overlay();
      if (!d) return;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      if (o) o.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var d = this.el(); var o = this.overlay();
      if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
      if (o) o.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    isOpen: function () { var d = this.el(); return d && d.classList.contains('is-open'); }
  };

  function bindCartUI() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); refreshCart().then(function(){ CartDrawer.open(); }); }
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { CartDrawer.close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { CartDrawer.close(); SearchModal.close(); }
    });
  }

  /* ----------------------------------------------------------------- CART API */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  // Replace the drawer's inner content from an HTML string. Returns true on success.
  function applyDrawerHTML(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-content]');
    var cur = $('[data-cart-content]');
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; return true; }
    return false;
  }

  // Re-render the cart drawer. Fast path: Section Rendering API.
  // Fallback: full-page fetch (the drawer is a layout section, so it's always
  // present in the page HTML even if the Section Rendering API can't address it).
  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
      .then(function (data) {
        if (!applyDrawerHTML(data && data['cart-drawer'])) throw new Error('no cart-drawer html');
      })
      .catch(function () {
        return fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) { applyDrawerHTML(html); })
          .catch(function () {});
      });
  }

  function addToCart(items, opts) {
    opts = opts || {};
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Array.isArray(items) ? { items: items } : items)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      return refreshCart().then(function () {
        if (opts.openDrawer !== false) CartDrawer.open();
        return cart;
      });
    });
  }

  function changeCart(key, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCart().then(function () { return cart; });
      });
  }

  function bindCartActions() {
    // Add-to-cart buttons (quick-add on cards, upsell pots)
    document.addEventListener('click', function (e) {
      var quick = e.target.closest('[data-quick-add]');
      var upsell = e.target.closest('[data-upsell-add]');
      var btn = quick || upsell;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = '…';
      addToCart({ id: id, quantity: 1 }).then(function () {
        if (upsell) { btn.textContent = '✓ Hinzugefügt'; btn.classList.add('is-added'); btn.disabled = false; }
        else { btn.textContent = '✓ Im Warenkorb'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500); }
      }).catch(function () { btn.textContent = original; btn.disabled = false; });
    });

    // Drawer qty +/- and remove
    document.addEventListener('click', function (e) {
      var up = e.target.closest('[data-qty-up]');
      var down = e.target.closest('[data-qty-down]');
      var rm = e.target.closest('[data-remove]');
      var node = up || down || rm;
      if (!node) return;
      e.preventDefault();
      var item = node.closest('[data-cart-item]');
      var key = node.getAttribute('data-key');
      var span = item ? item.querySelector('.fl-cd-step span, .fl-drawer-item__ctrls span') : null;
      var current = span ? parseInt(span.textContent, 10) : 1;
      var next = rm ? 0 : (up ? current + 1 : Math.max(0, current - 1));
      var onCartPage = document.body.classList.contains('template-cart');
      changeCart(key, next).then(function () { if (onCartPage) window.location.reload(); });
    });

    // Cross-Sell: Tab-Wechsel (rein clientseitig)
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-xsell-tab]');
      if (!tab) return;
      var root = tab.closest('[data-xsell]');
      if (!root) return;
      var key = tab.getAttribute('data-xsell-tab');
      $$('[data-xsell-tab]', root).forEach(function (b) { b.classList.toggle('is-active', b === tab); });
      $$('[data-xsell-panel]', root).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-xsell-panel') === key); });
    });

    // Cross-Sell: "+"-Button fügt hinzu und rendert den Drawer neu
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-xsell-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.disabled = true;
      addToCart({ id: id, quantity: 1 }, { openDrawer: false }).then(function () { btn.disabled = false; })
        .catch(function () { btn.disabled = false; });
    });
  }

  /* ----------------------------------------------------------------- PRODUCT FORM + VARIANTS */
  function initProductForm() {
    var section = $('[data-product-section]');
    if (!section) return;
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var priceEl = $('[data-price]', section);
    var addBtn = $('[data-add-to-cart]', section);
    var addLabel = $('[data-add-label]', section);
    var availEl = $('[data-availability]', section);
    var priceEls = $$('[data-price]', section);
    var addLabels = $$('[data-add-label]', section);
    var stickyBar = $('[data-stickybar]', section);
    var stickyAdd = $('[data-sticky-add]', section);
    var stickyVariant = $('[data-sticky-variant]', section);
    var stickySep = $('[data-sticky-sep]', section);
    var stickyQty = $('[data-sticky-qty]', section);
    var grossThreshold = parseInt(section.getAttribute('data-gross-threshold'), 10) || 1000;
    var isSet = (section.getAttribute('data-product-type') || '') === 'set';
    var shipEl = $('[data-ship]', section);
    var shipTextEl = shipEl ? $('[data-ship-text]', shipEl) : null;
    var sizeRef = $('[data-size-ref]', section);
    var sizeFill = sizeRef ? $('[data-size-fill]', sizeRef) : null;
    var sizeH = sizeRef ? $('[data-size-h]', sizeRef) : null;
    var sizeCmp = sizeRef ? $('[data-size-cmp]', sizeRef) : null;

    // "20cm – Ø13cm B" -> "20 cm · Ø 13 cm · B-Ware" (Sticky-Bar)
    function formatSizeLabel(key) {
      return String(key).split('~~').map(function (v) {
        var tag = ''; v = v.trim();
        if (/\(mehrtriebig\)/.test(v)) { tag = 'mehrtriebig'; v = v.replace(/\(mehrtriebig\)/, '').trim(); }
        if (/ B$/.test(v)) { tag = 'B-Ware'; v = v.replace(/ B$/, '').trim(); }
        v = v.replace(/cm/g, ' cm').replace(/\s*[\u2013\u2014-]\s*/, ' · ').replace(/Ø\s*/, 'Ø ').replace(/\s{2,}/g, ' ').trim();
        return tag ? v + ' · ' + tag : v;
      }).join(' · ');
    }
    // Alltagsvergleich zur Pflanzenhoehe (identisch zur Liquid-Logik in main-product.liquid)
    function sizeCompare(h) {
      if (h < 20) return 'etwa eine Handspanne';
      if (h < 35) return 'etwa ein DIN-A4-Blatt hochkant (30 cm)';
      if (h < 55) return 'etwa ein Nachttisch (45 cm)';
      if (h < 80) return 'etwa Tischhöhe (75 cm)';
      if (h < 120) return 'etwa eine Küchenarbeitsplatte (90 cm)';
      if (h < 170) return 'etwa ein Kühlschrank (1,50 m)';
      return 'etwa so groß wie ein Mensch (1,75 m)';
    }

    var mapNode = $('[data-options-map]', section);
    var optionsMap = {};
    try { optionsMap = JSON.parse(mapNode.textContent); } catch (e) {}

    var selected = {}; // position -> value
    $$('[data-option-value].is-active', section).forEach(function (b) {
      selected[b.getAttribute('data-position')] = b.getAttribute('data-value');
    });

    function currentKey() {
      var positions = Object.keys(selected).sort();
      return positions.map(function (p) { return selected[p]; }).join('~~');
    }

    function updateSelection() {
      var key = currentKey();
      var variant = optionsMap[key];
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (stickyAdd) { stickyAdd.disabled = true; }
        addLabels.forEach(function (el) { el.textContent = 'Nicht verfügbar'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      priceEls.forEach(function (el) { el.textContent = variant.price_formatted; });
      if (stickyVariant) {
        stickyVariant.textContent = formatSizeLabel(key);
        if (stickySep) stickySep.textContent = stickyVariant.textContent ? ' · ' : '';
      }
      // compare-at price
      var cmp = section.querySelector('[data-compare-price]');
      if (variant.compare && variant.compare > variant.price) {
        if (!cmp) {
          cmp = document.createElement('del');
          cmp.setAttribute('data-compare-price', '');
          priceEl.parentNode.insertBefore(cmp, priceEl);
        }
        cmp.textContent = variant.compare_formatted;
      } else if (cmp) { cmp.remove(); }

      // Paket vs. Grossformat: Versandzeile unter dem Preis variantenabhaengig
      var isGross = !isSet && (variant.grams || 0) >= grossThreshold;
      if (shipEl && shipTextEl) {
        shipTextEl.textContent = isSet ? shipEl.getAttribute('data-ship-set') : (isGross ? shipEl.getAttribute('data-ship-gross') : shipEl.getAttribute('data-ship-klein'));
      }
      // Groessen-Referenz
      var h = parseInt(variant.height, 10) || 0;
      if (sizeRef) {
        sizeRef.hidden = h === 0;
        if (sizeFill) sizeFill.style.width = Math.max(4, Math.min(100, Math.round(h / 200 * 100))) + '%';
        if (sizeH) sizeH.textContent = h + ' cm';
        if (sizeCmp) sizeCmp.textContent = sizeCompare(h);
      }
      // Verfuegbarkeit
      if (availEl) {
        var dot = '<span class="dot' + (variant.available ? '' : ' dot--out') + '"></span>';
        availEl.innerHTML = dot + (variant.available ? availEl.getAttribute('data-avail-in') : availEl.getAttribute('data-avail-out'));
      }

      if (addBtn) addBtn.disabled = !variant.available;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      addLabels.forEach(function (el) { el.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; });

      // show only this variant's media (+ shared)
      filterGalleryByVariant(variant.id);

      // update URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    $$('[data-option-value]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var pos = btn.getAttribute('data-position');
        selected[pos] = btn.getAttribute('data-value');
        // toggle active within same group
        $$('[data-option-value][data-position="' + pos + '"]', section).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateSelection();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        var qtyInput = $('[data-qty-input]', section);
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var original = addLabel ? addLabel.textContent : 'In den Warenkorb';
        addLabels.forEach(function (el) { el.textContent = '…'; });
        addToCart({ id: idInput.value, quantity: qty }).then(function () {
          addLabels.forEach(function (el) { el.textContent = '✓ Hinzugefügt'; });
          setTimeout(function () { addLabels.forEach(function (el) { el.textContent = original; }); }, 1600);
        }).catch(function () { addLabels.forEach(function (el) { el.textContent = original; }); });
      });
    }

    // Sticky-Bar-Button löst dasselbe Formular aus
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (stickyAdd.disabled) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    // Menge in die Sticky-Bar spiegeln
    var qtyInputEl = $('[data-qty-input]', section);
    function syncStickyQty() { if (stickyQty && qtyInputEl) stickyQty.textContent = qtyInputEl.value || '1'; }
    if (qtyInputEl) {
      qtyInputEl.addEventListener('input', syncStickyQty);
      qtyInputEl.addEventListener('change', syncStickyQty);
    }
    var qtyWrapEl = $('[data-qty-wrap]', section);
    if (qtyWrapEl) qtyWrapEl.addEventListener('click', function () { setTimeout(syncStickyQty, 0); });
    syncStickyQty();

    // Sticky-Bar einblenden, sobald der Haupt-CTA aus dem Sichtfeld scrollt
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stickyBar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -32px 0px' });
      io.observe(addBtn);
    }

    // Initiale Galerie-Filterung auf die vorausgewählte Variante
    if (idInput && idInput.value) filterGalleryByVariant(idInput.value);

    // Ein Kundenzitat, alle 6 s weiterblaettern (pausiert bei reduzierter Bewegung)
    var rot = $('[data-quote-rot]', section);
    if (rot) {
      var quotes = $$('.fl-buy__quote', rot);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (quotes.length > 1 && !reduce) {
        var qi = 0;
        setInterval(function () {
          qi = (qi + 1) % quotes.length;
          quotes.forEach(function (q, i) { q.classList.toggle('is-active', i === qi); });
        }, 6000);
      }
    }
  }

  /* ----------------------------------------------------------------- QTY STEPPERS (PDP) */
  function bindQtySteppers() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-qty-wrap]');
      var input = wrap ? wrap.querySelector('[data-qty-input]') : null;
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      input.value = plus ? val + 1 : Math.max(1, val - 1);
    });
  }

  /* ----------------------------------------------------------------- GALLERY */
  function selectGallery(index) {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    var slides = $$('[data-slide]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    if (index < 0 || index >= slides.length) return;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    var dots = $$('.fl-gal__dot', gallery);
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
  }
  // Punkt-Navigation (Mobile) aus den aktuell sichtbaren Slides aufbauen
  function buildDots() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    var wrap = $('[data-gal-dots]', gallery);
    if (!wrap) return;
    var slides = $$('[data-slide]', gallery);
    var visible = slides.filter(function (s) { return s.style.display !== 'none'; });
    var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (activeIdx < 0) activeIdx = 0;
    wrap.innerHTML = '';
    visible.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fl-gal__dot' + (i === activeIdx ? ' is-active' : '');
      b.setAttribute('aria-label', 'Bild ' + (i + 1));
      b.addEventListener('click', function () { selectGallery(i); });
      wrap.appendChild(b);
    });
  }
  // Perf: Bilder inaktiver Varianten kommen ohne src (data-src/data-srcset) vom Server.
  // Erst beim Sichtbarmachen (Varianten-Wechsel) werden sie hydriert und geladen.
  function hydrateImgs(el) {
    if (!el || !el.querySelectorAll) return;
    Array.prototype.forEach.call(el.querySelectorAll('img[data-src]'), function (img) {
      var ss = img.getAttribute('data-srcset');
      var sz = img.getAttribute('data-sizes');
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
      if (sz) { img.setAttribute('sizes', sz); img.removeAttribute('data-sizes'); }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    });
  }
  // Show only media belonging to the selected variant (data-show-for) + shared ("all").
  // Reorder so the variant's own image comes first, then shared, then hidden (display:none).
  function filterGalleryByVariant(variantId) {
    var gallery = $('[data-gallery]');
    if (!gallery || !variantId) return;
    var vid = String(variantId);
    function reorder(items, wrap) {
      if (!wrap || !items.length) return 0;
      var owned = [], shared = [], hidden = [];
      items.forEach(function (el) {
        var o = el.getAttribute('data-show-for');
        if (o === vid) owned.push(el);
        else if (o === 'all') shared.push(el);
        else hidden.push(el);
      });
      owned.forEach(function (el) { hydrateImgs(el); el.style.display = ''; wrap.appendChild(el); });
      shared.forEach(function (el) { hydrateImgs(el); el.style.display = ''; wrap.appendChild(el); });
      hidden.forEach(function (el) { el.style.display = 'none'; wrap.appendChild(el); });
      return owned.length + shared.length;
    }
    var thumbsWrap = $('.fl-gal__thumbs', gallery);
    var mainWrap = $('.fl-gal__main', gallery);
    reorder($$('[data-thumb]', gallery), thumbsWrap);
    var visible = reorder($$('[data-slide]', gallery), mainWrap);
    // After reordering, index 0 is the variant's own image (or first shared).
    if (visible > 0) selectGallery(0);
    buildDots();
  }
  function bindGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    $$('[data-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectGallery(parseInt(thumb.getAttribute('data-thumb'), 10)); });
    });
    buildDots();
    // Swipe-Gesten auf dem Hauptbild (Mobile)
    var main = $('.fl-gal__main', gallery);
    if (main) {
      var startX = 0, startY = 0;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var visible = $$('[data-slide]', gallery).filter(function (s) { return s.style.display !== 'none'; });
        if (visible.length < 2) return;
        var cur = visible.findIndex(function (s) { return s.classList.contains('is-active'); });
        if (cur < 0) cur = 0;
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next < 0) next = visible.length - 1;
        if (next >= visible.length) next = 0;
        selectGallery(next);
      }, { passive: true });
    }
  }

  /* ----------------------------------------------------------------- MOBILE NAV */
  function bindMobileNav() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      nav.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ----------------------------------------------------------------- SEARCH MODAL + PREDICTIVE */
  var SearchModal = {
    el: function () { return $('[data-search-modal]'); },
    open: function () { var m = this.el(); if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); var i = $('[data-search-input]', m); if (i) i.focus(); } },
    close: function () { var m = this.el(); if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); } }
  };
  function bindSearch() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); SearchModal.open(); }
      if (e.target.closest('[data-search-close]')) { SearchModal.close(); }
      if (e.target.matches('[data-search-modal]')) { SearchModal.close(); }
    });
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results || !routes.predictive_search_url) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          }).catch(function () {});
      }, 220);
    });
  }

  /* ----------------------------------------------------------------- COUNT-UP */
  function bindCountUp() {
    var els = $$('[data-countup]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseInt(el.getAttribute('data-target'), 10);
        var suffix = (el.textContent.match(/[^0-9.,]+$/) || [''])[0];
        if (isNaN(target)) return;
        var start = 0, dur = 1400, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = val.toLocaleString('de-DE') + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------------- PRODUCT RECOMMENDATIONS */
  function loadRecommendations() {
    var el = $('[data-product-recommendations]');
    if (!el) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ----------------------------------------------------------------- INIT */
  function init() {
    bindCartUI();
    bindCartActions();
    initProductForm();
    bindQtySteppers();
    bindGallery();
    bindMobileNav();
    bindSearch();
    bindCountUp();
    loadRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
